/**
 * NDL EU-Gewährleistungshinweis
 * =============================
 * Öffnet das native <dialog> aus snippets/ndl-eu-gewaehrleistung.liquid per showModal().
 * Das amtliche SVG ist loading="lazy" und wird erst beim Öffnen auf eager gestellt.
 * Schließen per X, Escape (nativ) oder Klick auf den Hintergrund; danach Fokus zurück
 * auf den Auslöser.
 */
(function () {
  'use strict';

  if (window.customElements.get('ndl-eu-gewaehrleistung')) return;

  class NdlEuGewaehrleistung extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.ndl_gewaehrleistung__trigger');
      this.dialog = this.querySelector('.ndl_gewaehrleistung__dialog');
      this.closeButton = this.querySelector('.ndl_gewaehrleistung__close');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.trigger.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
        if (!inside) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.trigger.focus());
    }

    open() {
      this.dialog.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      this.dialog.showModal();
    }
  }

  window.customElements.define('ndl-eu-gewaehrleistung', NdlEuGewaehrleistung);
})();
